import { makeStyles, Paper, TextField, Theme } from '@material-ui/core';
import React from 'react';

import { spacings } from '../../../../theme';
import { PlexButton } from '../../primitives/PlexButton';

type Value = {
  text: string;
  url: string;
};

type Props = {
  value: Value;
  onChange: (value: Value) => void;

  onSave: () => void;
};

export const LinkEdit = ({ value, onChange, onSave }: Props): React.ReactElement => {
  const classes = useStyles();
  const canSave = value.text.length > 0 && value.url.length > 0;

  return (
    <Paper className={classes.root}>
      <div>
        <TextField
          className={classes.editLinkField}
          variant="outlined"
          label="Text"
          size="small"
          value={value.text}
          onChange={(e): void => {
            onChange({ ...value, text: e.currentTarget.value });
          }}
          fullWidth
        />
        <TextField
          className={classes.editLinkField}
          variant="outlined"
          label="Link"
          size="small"
          value={value.url}
          onChange={(e): void => {
            onChange({ ...value, url: e.currentTarget.value });
          }}
          fullWidth
        />
      </div>
      <div className={classes.editLinkActions}>
        <PlexButton label="Apply" onClick={onSave} size="small" disabled={!canSave} />
      </div>
    </Paper>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: 400,
    color: theme.palette.common.black,
    padding: spacings.normal,

    display: 'flex',
    justifyContent: 'space-between',
  },
  editLinkField: {
    margin: spacings.xsmall,
  },
  editLinkActions: {
    marginLeft: spacings.normal,
  },
}));
